// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1EJp3","btn":"styles_btn__o6aOL","text":"styles_text__3AIhP","targetTitle":"styles_targetTitle__340Br"};